exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MainPhoto-1e6d9638{flex:1;margin:0;padding:0;min-height:0;display:flex;justify-content:center;align-items:center;position:relative;text-align:center}.prev-d5944cbc,.next-d1d9b3b0{flex:1;top:0;bottom:0;width:5vw;min-width:50px;display:flex;align-items:center;justify-content:center;color:white;opacity:0.3;transition:opacity 0.2s ease-in-out;cursor:pointer;z-index:3;height:100%}.prev-d5944cbc:hover,.next-d1d9b3b0:hover{opacity:0.6}.stage-9cd4346a{overflow:hidden;height:100%;display:flex;flex-direction:column;min-width:700px;align-items:center}.stageTop-a898897d{flex:1}.stageBottom-a83208e8{flex:1;width:100%}.photo-0869667a{flex:0 0;-webkit-user-select:none;user-select:none}.layoutPending-14974ea4{opacity:0}.spinner-2b789210{flex:0 0;height:40;width:40}\n", ""]);

// Exports
exports.locals = {
	"MainPhoto": "MainPhoto-1e6d9638",
	"prev": "prev-d5944cbc",
	"next": "next-d1d9b3b0",
	"stage": "stage-9cd4346a",
	"stageTop": "stageTop-a898897d",
	"stageBottom": "stageBottom-a83208e8",
	"photo": "photo-0869667a",
	"layoutPending": "layoutPending-14974ea4",
	"spinner": "spinner-2b789210"
};